module.exports = __webpack_public_path__ + "img/install-app.1e6e0cf4.svg";